import { Routes } from './components/Routes'
import { DateInput } from '@/components/DateInput'

import styles from './Workstation.module.scss'
import { useSharedRoutesStore } from '../store'

export const ShareLogWorkstation = () => {
    const { sharedRoutes } = useSharedRoutesStore()

    return (
        <div className={styles.root}>
            <div className={styles.header}>
                <h2 className={styles.routeTitle}>Route {sharedRoutes.length > 0 && sharedRoutes[0]?.route}</h2>
                <DateInput disabled />
            </div>
            <Routes isShared isEditable={false} />
        </div>
    )
}
